import React, { useRef } from 'react';

const CardExamesLaboratoriais = ({ infoCard }) => {

  return (
    <>
      <div className='card card-exames-laboratoriais'>
        <div className='card-header'>
          <div className='card-title'>Pacientes Aguardando Exames Laboratoriais</div>
          <div className='card-total'>{infoCard.totalPacientes}</div>
          <div className='card-grupo'>
            <div className={'card-tipo card-adulto ' + infoCard.corAdulto}>
              <span className='card-tipo-desc'>PS Adulto</span>
              <span className='card-tipo-total'>{infoCard.totalAdulto}</span>
            </div>
            <div className={'card-tipo card-infantil ' + infoCard.corInfantil}>
              <span className='card-tipo-desc'>PS Infantil</span>
              <span className='card-tipo-total'>{infoCard.totalInfantil}</span>
            </div>
          </div>
          <div className='card-status'>
            <div className='card-grupo'>
              <span className='card-status-desc'>Maior tempo aguardando</span>
              <span className='card-status-tempo'>{infoCard.maiorTempo}</span>
            </div>
            <div className={"card-status-bar " + infoCard.corMaiorTempo}></div>
          </div>
        </div>
        <div className='card-grupo'>
          <div className='card-footer'>
            <div className='card-title'>Aguard. Coleta</div>
            <div className='card-footer-total'>{infoCard.totalColeta}</div>
            <div className='card-footer-status'>Maior tempo</div>
            <div className='card-footer-tempo'>
              <span>{infoCard.maiorTempoColeta}</span>
              <span className={"sla-dot " + infoCard.corMaiorTempoColeta}></span>
            </div>
          </div>
          <div className='card-footer'>
            <div className='card-title'>Aguard. Laudo</div>
            <div className='card-footer-total'>{infoCard.totalLaudo}</div>
            <div className='card-footer-status'>Maior tempo</div>
            <div className='card-footer-tempo'>
              <span>{infoCard.maiorTempoLaudo}</span>
              <span className={"sla-dot " + infoCard.corMaiorTempoLaudo}></span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CardExamesLaboratoriais;